/*
  Base file for stub.
  This is where all the actual stub code will go.
*/

// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import render from "../../utilities/render";
import {setOptionsForSelect} from "../../utilities/selectorHelpers";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import { isNullOrUndefined, isUndefined } from "util";
import { isBlank } from "../../utilities/general";
require("./standardPlatformFacilitySetupWizard.less");
import { setSwitchery, instantiateSwitchery } from '../../utilities/instantiateSwitchery'; 
import timePicker from "../../components/timePicker/timePicker";
// Additional Imports...
//import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

//const modalHtml = require("../../sharedHtml/modal.html");
const certificateRowHtml = require("./html/certificateRow.html");

const elementsMap = {
  detailsfacleasedropdown:".fac-leased-select",
  detailsfacowneddropdown:".fac-owned-select",
  facilityCode:"#fac-code",
  detailsfacname: "#fac-name",
  detailsfacbldgno: "#fac-bldgno",
  detailsfacbusunit: "#fsc-business-unit",  
  detailsfacgolivedate:".facility-go-live-date",
  detailsfacleasedradio:".leased",
  detailsfacownedradio:".owned",
  detailsfacleasedselect:".fac-leased-select",
  detailsfacownedselect:".fac-owned-select",
  detailsfaccloseddate:"#facility-closed-date-parent",
  detailsfacdefaultcert:".first-certificate" 
  
}
let els = {};



export default function DetailsTab(wizard){
  const self = this;
  const wizardEl = wizard.getWizardElement();
  const addCertificateBtn = wizardEl.find("#add-certificate");

  // HB-11242 - Load all data from controller
  const fscBusinessUnits = wizardEl.data("fsc-businesss-units");
  const facilityOwners = wizardEl.data("facility-owners");
  const facilityLessee = wizardEl.data("facility-lessee");
  const fscBusinessUnitSelect = wizardEl.find(".fsc-business-unit");
  const fscFacilityLesseeSelect= wizardEl.find(".fac-leased-select");
  const fscFacilityOwnerSelect = wizardEl.find(".fac-owned-select");
  const fscOwenershipRadio = wizardEl.find(".ownership-radio");
  const fscLeasedRadio = wizardEl.find(".leased");
  const fscOwenedRadio = wizardEl.find(".owned");
  const splFacilityEl = $('#standard-platform-facility-setup-wizard');
  const facCodeCheckUrl = splFacilityEl.attr("data-fac-code-check-url");
  const facCertificateSwitch = wizardEl.find("#fac-certificate-switch");
  const facData = wizardEl.data("load-edit-facility"); //get the facility data from DB to load edit form
  let facId = 0;
  
  self.init = function(){
    setElements(); 
    load();
    bindElements();
    loadEditForm(); //load saved facilities back to form 
  };

  function setElements(){
    setElementsFromScope(els, elementsMap, wizardEl);
  }

  function load(){
    setOptionsForSelect({
	    	selectElement: fscBusinessUnitSelect,
	    	list: fscBusinessUnits,
	    	valueDataKey: "cdmMeaning",
	    	textDataKey: "cdmDescription"
	  	});

      setOptionsForSelect({
  	    	selectElement: fscFacilityLesseeSelect,
  	    	list: facilityLessee,
  	    	valueDataKey: "cdmMeaning",
  	    	textDataKey: "cdmDescription"
  	  });

      setOptionsForSelect({
  	    	selectElement: fscFacilityOwnerSelect,
  	    	list: facilityOwners,
  	    	valueDataKey: "cdmMeaning",
  	    	textDataKey: "cdmDescription"
      });
  }

  function bindElements(){
    els.facilityCode.on("keyup", hideErrorMsg);
    els.facilityCode.on("blur", validateFacilityCode);   
  }

    
  addCertificateBtn.on('click', function(e){
    addCertificates(e);
  });

  fscOwenershipRadio.on('change', function(e) {
    e.preventDefault();
    
    if(fscLeasedRadio.is(":checked")){
      fscFacilityLesseeSelect.prop('disabled', false); 
      fscFacilityOwnerSelect.prop('disabled', true); 
      els.detailsfacowneddropdown.val("").trigger('change');
    }else if(fscOwenedRadio.is(":checked")){
      fscFacilityLesseeSelect.prop('disabled', true); 
      fscFacilityOwnerSelect.prop('disabled', false); 
      els.detailsfacleasedropdown.val("").trigger('change');
    }    
    return true;
  });

  //added to hide certificate error message when switchery is OFF.
  facCertificateSwitch.on('change', function(e){ 
    if(!facCertificateSwitch.is(":checked")){
      $("#facility-certifications-error").hide();   
    }
  });

  function addCertificates(e) {
    e.preventDefault();
    
    const countElement = $('#certificates').length || 0  
    const certificateRow = render(certificateRowHtml,{
      highestId: countElement
    });
    wizardEl.find("#certificate-div").append(certificateRow);
  }
  
  $('#certificate-div').on('click', '.remove_certficate_row', function(e){
    e.preventDefault();
    if($(this).hasClass('first-certificate-remove')){
      //clear value 
      els.detailsfacdefaultcert.val("") ;      
    }else{
      $(this).closest('.certificate').remove();      
    } 
  });  

  function hideErrorMsg() {
    const facCode = els.facilityCode.val();    
    if(isNullOrUndefined(facCode) || isBlank(facCode)){
      splFacilityEl.find('#dup-facCode').hide();
    }
  }

  function validateFacilityCode() {
    const facCode = els.facilityCode.val();
    if(!isNullOrUndefined(facCode) && !isBlank(facCode)){
      $.ajax({
        data: {
          splFacilityCode:  facCode,
          splFacilityId :  facId
        },
        url: facCodeCheckUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){
           if(data.response== true) {
             splFacilityEl.find('#dup-facCode').show(); 
             return false;
           }else{
             splFacilityEl.find('#dup-facCode').hide();
             return true;
           }  
        }  
     });
    }     
  }

  //Load saved facility DB values on form for edit purpose.

  function loadEditForm(){
    let ownership;
    let owner;
    
    if(facData != null && facData != ''){
      facId = facData.facId;
      els.detailsfacname.val(facData.facName);
      els.facilityCode.val(facData.facCode);
      els.detailsfacbldgno.val(facData.facBuildingNumber);
      if(facData.facBusinessUnit != null){
        els.detailsfacbusunit.val(facData.facBusinessUnit);
      }      
      
      //Iterate through attributes rows.

      const facAttributesData = new Set(facData.facilitiesAttributesSet);
      let savedCertificates =[]; //holds certificates in the order of insertion by user on ui.
      let savedCertFromDB = new Map();  //newresearch

      for (let keyval of facAttributesData) {
        let arr_names = new Array(keyval);
        for(let j=0;j<arr_names.length;j++){
          let attrName;
          let attrValue;
          let attrId; //newresearch
          for (let k of Object.keys(arr_names[j])) {
            if(k == "faaKey"){
              attrName = (arr_names[j])[k];
            }else if(k == "faaValue"){
              attrValue = (arr_names[j])[k];
            }else if (k == "faaId"){  //newresearch             
              attrId = (arr_names[j])[k];
            }

           }
           if(attrName!=null && attrValue!=null){
            if(attrName == "FAC_OWNERSHIP_ATTR"){
                ownership = attrValue;
                if(attrValue== "Leased"){
                  els.detailsfacleasedradio.prop('checked', true);
                  if(!isBlank(owner)){
                    els.detailsfacleasedselect.val(owner);
                    fscFacilityLesseeSelect.prop('disabled', false); 
                  }
                }else if (attrValue== "Owned"){
                 els.detailsfacownedradio.prop('checked', true);
                 if(!isBlank(owner)){
                  els.detailsfacownedselect.val(owner);  
                  fscFacilityOwnerSelect.prop('disabled', false); 
                }
                }
            }else if(attrName == "FAC_OWNER_ATTR"){
              owner =  attrValue;  
              if(ownership == "Leased"){
                els.detailsfacleasedselect.val(attrValue);
                fscFacilityLesseeSelect.prop('disabled', false);       
              }else if(ownership == "Owned"){
                els.detailsfacownedselect.val(attrValue);  
                fscFacilityOwnerSelect.prop('disabled', false); 
              }
            }else if(attrName == "FAC_CERTIFICATES_FLAG_ATTR"){
              if(attrValue == "yes"){                
                  instantiateSwitchery(facCertificateSwitch,true);
                  setSwitchery(facCertificateSwitch,true);
              }
            }else if(attrName == "FAC_YARD_MANAGEMENT_ATTR"){
              if(attrValue == "yes"){
              $('#yardmanagement').prop("checked",true);
              }
            }else if(attrName == "FAC_ACCEPT_INBOUND_APPOINTMENT_ATTR"){
              if(attrValue == "yes"){
              $('#inboundappointment').prop("checked",true);
              }
            }else if(attrName == "FAC_CERTIFICATE_ATTR"){
              //savedCertificates.push(attrValue);
              savedCertFromDB.set(attrId,attrValue); //newresearch   
            }      
          }
        }  
      }

       //newresearch   - starts
       if(savedCertFromDB != null){
        let sortedCertMapAsc = new Map([...savedCertFromDB.entries()].sort());

        sortedCertMapAsc.forEach((value, key) => {
          savedCertificates.push(value);
        });
       }

       if(savedCertificates.length >0 ){
        if(savedCertificates.length == 1){
          els.detailsfacdefaultcert.val(savedCertificates[0]) ;
        }else{
          let index = 0;
          savedCertificates.forEach(function (value) {
            if(index == 0){
              els.detailsfacdefaultcert.val(savedCertificates[index]) ;
            }else{
              addCertificateBtn.click();
              $("input[name='certificate']").each(function() {
                if(isBlank($(this).val())){
                  $(this).val(savedCertificates[index]);
                }
              });
            }
            index++;
          });
        }
      }

    }
  }


}


// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/detailsTab.js